import React from "react";

import DbtCoreLogo from "@/assets/dbt/dbt-core.svg?react";
import DbtCoreLogoWhite from "@/assets/dbt/dbt-core_white.svg?react";
import DbtLogo from "@/assets/dbt/dbt.svg?react";
import DbtLogoWhite from "@/assets/dbt/dbt_white.svg?react";
import { useTheme } from "@/providers/ThemeProvider";

export function DbtCoreIcon(props: React.ComponentProps<typeof DbtCoreLogo>) {
  const { isDarkMode } = useTheme();
  return isDarkMode ? (
    <DbtCoreLogoWhite {...props} />
  ) : (
    <DbtCoreLogo {...props} />
  );
}

export function DbtIcon(props: React.ComponentProps<typeof DbtCoreLogo>) {
  const { isDarkMode } = useTheme();
  return isDarkMode ? <DbtLogoWhite {...props} /> : <DbtLogo {...props} />;
}
